import { render } from "./Can.vue?vue&type=template&id=59a329eb&ts=true"
import script from "./Can.vue?vue&type=script&lang=ts"
export * from "./Can.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__